module.exports = __webpack_public_path__ + "img/clogo.f7430b48.png";